<template>
  <div class="member-list">
    <!--div class="loading" v-if="dojo === null"></div>
    <p>dojo: {{dojo}} </p>
    <p>events: {{events}} </p>
    <p>members: {{members}} </p>
    <p>branches: {{branches}} </p>
    <p>staff: {{staff}} </p>
    <p>media: {{media}} </p-->
    <div class="container" v-if="dojo !== null">  
      
      <div class="details-outer">
      
        <div class="details-title-box details-box-with-image" :class="{open: branchesOpen}">  
          <div class="details-box-image-area">  
            <img :src="logoPath + dojo.id + '.jpg'" @error="onLogoImageError"/>
          </div>
          <div class="details-box-text-area">  
            <h1>{{dojo.dojo}}</h1>
            <div class="details-box-address">   
              <a class="address-locator" :href="'https://maps.google.com/?q=' + dojo.address + ' ' + dojo.zip + ' ' + dojo.city + ' ' + dojo.dojo" target="_blank"></a>            
              <div class="details-box-address-text">  
                <p>{{dojo.address}}</p>
                <p>{{dojo.zip}} {{dojo.city}}</p>
                <p class="country-label"><img class="details-flag" :src="flagsPath + dojo.country_img"/> {{dojo.country}}</p>
                <p><a :href="'//' + dojo.url" target="_blank" v-html="makeDashNoBreak((dojo.url).toLowerCase())"></a></p>
              </div>
              <div class="dojo-branches-outer" v-if="branches.length > 0">  
                <p class="dojo-branches-title"><span>{{branches.length}} branches in:</span></p>
                <div class="dojo-branches">  
                  <div class="dojo-branches-more" v-if="branches.length > 4" @click="branchesOpen = !branchesOpen" :class="{turn180: branchesOpen}">
                    <i class="fas fa-caret-down"></i>
                  </div>
                  <div class="dojo-branch" v-for="item in branches" :key="item.id">
                    <div class="dojo-branch-location">  
                      <a :href="'https://maps.google.com/?q=' + item.address + ' ' + item.zip + ' ' + item.city + ' ' + dojo.dojo" target="_blank"><i class="fas fa-map-marker-alt"></i></a>
                    </div>
                    <div class="dojo-branch-title">{{item.city}}</div>                
                    <div class="dojo-branch-subline">{{item.address}}</div>                
                  </div>
                </div>
              </div>            
            </div>            
          </div>

          
        </div>
      
        <div class="details-social-links" v-if="media.links.social">          
          <a v-if="media.links.social.facebook" :href="media.links.social.facebook" target="_blank"><i class="fab fa-facebook"></i></a>
          <a v-if="media.links.social.xing" :href="media.links.social.xing" target="_blank"><i class="fab fa-xing"></i></a>
          <a v-if="media.links.social.twitter" :href="media.links.social.twitter" target="_blank"><i class="fab fa-twitter"></i></a>
          <a v-if="media.links.social.googleplus" :href="media.links.social.googleplus" target="_blank"><i class="fab fa-google-plus-g"></i></a>
          <a v-if="media.links.social.linkedin" :href="media.links.social.linkedin" target="_blank"><i class="fab fa-linkedin"></i></a>
        </div>
        
          
        <div class="details-left">   
            <div class="details-box" v-if="staff.ownerMembers.members.length > 0">
              <h2>Head of Dojo</h2>
              <div class="list-item" v-for="item in staff.ownerMembers.members" :key="item.map" @click="goMember(item)">  
                <div class="list-item-image">  
                  <img :src="item.memberImage"/>
                </div>
                <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
                <div class="list-item-subtitle">{{item.datumStart}}</div>
              </div>
            </div>

            
            <div class="details-box" v-if="staff.contactMembers.members.length > 0">
              <h2>Contact</h2>
              <div class="list-item" v-for="item in staff.contactMembers.members" :key="item.map" @click="goMember(item)">  
                <div class="list-item-image">  
                  <img :src="item.memberImage"/>
                </div>
                <div class="list-item-caption">
                  <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
                  <div class="list-item-subtitle">{{item.dojo}}</div>
                </div>
              </div>
            </div>
            
            <div class="details-box" v-if="staff.trainerMembers.members.length > 0">
              <h2>Trainers</h2>
              <div class="list-item" v-for="item in staff.trainerMembers.members" :key="item.map" @click="goMember(item)">  
                <div class="list-item-image">  
                  <img :src="item.memberImage"/>
                </div>
                <div class="list-item-caption">
                  <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
                  <div class="list-item-subtitle">{{item.dojo}}</div>
                </div>
              </div>
            </div>
            
            <div class="details-box" v-if="staff.administrationMembers.members.length > 0">
              <h2>Administration</h2>
              <div class="list-item" v-for="item in staff.administrationMembers.members" :key="item.map" @click="goMember(item)">  
                <div class="list-item-image">  
                  <img :src="item.memberImage"/>
                </div>
                <div class="list-item-caption">
                  <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
                  <div class="list-item-subtitle">{{item.dojo}}</div>
                </div>
              </div>
            </div>
            
            <div class="details-box" v-if="staff.honoraryMembers.members.length > 0">
              <h2>Honorary Members</h2>
              <div class="list-item" v-for="item in staff.honoraryMembers.members" :key="item.map" @click="goMember(item)">  
                <div class="list-item-image">  
                  <img :src="item.memberImage"/>
                </div>
                <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
                <div class="list-item-subtitle">{{item.datumStart}}</div>
              </div>
            </div>
          
          <div class="details-box" v-if="events.length > 0">  
            <h2>Upcoming events</h2>
            <div class="list-item" v-for="item in events" :key="item.id">  
              <div class="list-item-caption">
                <div class="list-item-title">{{item.title}}</div>
                <div class="list-item-subtitle">{{item.datumStart}}</div>
              </div>
              <div class="list-item-additionals">
                <div class="list-item-additional">{{item.kategorie}}</div>                    
                <div class="list-item-additional">               
                  <div>{{item.city}}</div>                    
                  <div>{{item.street}}</div>                    
                </div>                    
              </div> 
            </div>
          </div>
          
          <div class="details-box" v-if="media.videos.data.length > 0">  
            <h2>Videos</h2>
            <div class="list-video-outer" v-for="item in media.videos.data" v-html="createYouTubeEmbed(item.link)"></div>  
          </div>
          
          <div class="details-box" v-if="media.links.general.length > 0">  
            <h2>Recommended</h2>
            <div class="details-box-sub-text-link" v-for="item in media.links.general">  
              <a :href="item" target="_blank">{{item}}</a>
            </div>
          </div>
          
        </div>
        
        
        <div class="details-right"> 

          <div class="loading-partial" v-if="members.length === 0"></div>
          
          <div class="details-box" v-if="members.length > 0">  
            <h1>Dojo members</h1>
            <span class="light">{{members.length}} {{$t('message.membersFound')}}</span>
            <hr>
            <div class="details-list">  
                <div class="list-item" v-for="item in members" @click="goMember(item)" :key="item.map">  
                  <div class="list-item-image">  
                    <img :src="item.memberImage" @error="onImageError"/>
                  </div>
                  <div class="list-item-caption">
                    <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
                    <div class="list-item-subtitle">MAP {{item.map}}</div>
                  </div>
                  <div class="list-item-additionals">
                    <div class="list-item-additional"><img :src="beltsPath + item.belt_img"/></div>                    
                  </div> 
                </div>
              </div>        
          </div>
          
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'dojo',
  data () {
    return {
      id: 0,
      socialLinks: {
        facebook: null,
        xing: null,
        googleplus: null,
        twitter: null,
        linkedin: null
      },
      branchesOpen: false
    }
  },
  methods: {
    getDojo: function () {
      this.$store.dispatch('dojos/getDetails', this.id).then(() => {
        this.getMembers()
        this.getDojoBranches()
        this.getEvents()
        this.getMedia()
        this.getDojoStaff()
      })
    },
    getDojoBranches: function () {
      this.$store.dispatch('dojos/getBranches', this.id)
    },
    getMembers: function () {
      this.$store.dispatch('dojos/getMembers', this.id)
    },
    getEvents: function () {
      this.$store.dispatch('dojos/getEvents', this.id)
    },
    getMedia: function () {
      this.$store.dispatch('dojos/getMedia', this.id)
    },
    getDojoStaff: function () {
      this.$store.dispatch('dojos/getStaff', this.id)
    },
    makeDashNoBreak: function (string) {
      return string.replace('-', '&#8209')
    },
    getYouTubeId: function (link) {
      var videoId = link.split('v=')[1]
      var ampersandPosition = videoId.indexOf('&')
      if (ampersandPosition !== -1) {
        videoId = videoId.substring(0, ampersandPosition)
      }
      return videoId
    },
    createYouTubeEmbed: function (link) {
      var videoId = this.getYouTubeId(link)
      var iframeMarkup = '<iframe width="320" height="180" src="//www.youtube.com/embed/' + videoId + '" frameborder="0" allowfullscreen></iframe>'
      return iframeMarkup
    },
    getSocialLink: function (key) {
      var link = null
      _.forEach(this.media.links, function (value) {
        if (value.bez === key) {
          link = value.link
        }
      })
      return link
    },
    goMember: function (item) {
      var breadcrumb = {
        name: item.firstname + ' ' + item.lastname,
        route: '/member/' + item.map
      }
      this.$store.commit('ADD_BREADCRUMB', breadcrumb)
      this.$router.push(breadcrumb.route)
    },
    onLogoImageError: function (event) {
      event.target.src = './dojo-dummy.png'
    },
    onImageError: function (event) {
      event.target.src = './person-dummy.png'
    }
  },
  computed: {
    ...mapGetters({
      dojo: 'dojos/details',
      members: 'dojos/members',
      media: 'dojos/media',
      branches: 'dojos/branches',
      events: 'dojos/events',
      staff: 'dojos/staff',
      logoPath: 'dojos/logoPath',
      flagsPath: 'countries/flagsPath',
      beltsPath: 'members/beltsPath'
    })
  },
  activated: function () {
    this.id = this.$route.params.id
    this.getDojo()
    console.log('branches:')
    console.log(this.branches)
  }
}
</script>
